/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Intake_Why_How_Heard_ShortInputs */

const en_us2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Just for us to know. It does not change your plan`)
};

const pt_br2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só para a gente saber. Não muda o plano`)
};

const es_419_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo para que lo sepamos. No cambia tu plan`)
};

const pt_pt2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Só para sabermos. Não muda o plano`)
};

const fr_fr2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Juste pour notre info. Ça ne change pas ton programme`)
};

const de_de2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Nur für uns. Ändert deinen Plan nicht`)
};

const it_it2_intake_why_how_heard_short = /** @type {(inputs: Intake_Why_How_Heard_ShortInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Solo per saperlo. Non cambia la tua scheda`)
};

/**
* | output |
* | --- |
* | "Just for us to know. It does not change your plan" |
*
* @param {Intake_Why_How_Heard_ShortInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const intake_why_how_heard_short = /** @type {((inputs?: Intake_Why_How_Heard_ShortInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Intake_Why_How_Heard_ShortInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_intake_why_how_heard_short(inputs)
	if (locale === "es-419") return es_419_intake_why_how_heard_short(inputs)
	if (locale === "pt-PT") return pt_pt2_intake_why_how_heard_short(inputs)
	if (locale === "fr-FR") return fr_fr2_intake_why_how_heard_short(inputs)
	if (locale === "de-DE") return de_de2_intake_why_how_heard_short(inputs)
	if (locale === "it-IT") return it_it2_intake_why_how_heard_short(inputs)
	return en_us2_intake_why_how_heard_short(inputs)
});
export { intake_why_how_heard_short as "intake.why.how_heard.short" }